import { countPlacedDesignerPanels } from '../inverter/inverter-transitions';

export const CANVAS_ACCORDION_KEYS = ['segments', 'obstacles', 'trees'];

export function deriveAccordionModeAndTool(
  currentAccordion,
  { currentTab = null } = {}
) {
  let mode = CANVAS_ACCORDION_KEYS.includes(currentAccordion)
    ? 'draw'
    : 'select';
  let tool = 'Polygon';

  if (currentAccordion === 'segments' && currentTab === 'segment-labels') {
    mode = 'label';
  }
  if (currentAccordion === 'trees') {
    tool = 'Circle';
  }

  return { mode, tool };
}

export function transitionAccordion(
  state,
  currentAccordion,
  { currentTab = state.currentTab } = {}
) {
  const { mode, tool } = deriveAccordionModeAndTool(currentAccordion, {
    currentTab
  });
  const nextState = {
    ...state,
    currentAccordion,
    mode,
    tool,
    losses: state.losses
  };

  if (currentAccordion === 'design') {
    nextState.selectionMode = 'segment';
    nextState.selectedObjects = {
      ...(state.selectedObjects || {}),
      panels: {}
    };
  }

  return nextState;
}

export function patchPlacementPrefs(state, prefs = {}) {
  const next = { ...state };
  if (prefs.panelPlacementFillMode !== undefined) {
    next.panelPlacementFillMode = prefs.panelPlacementFillMode;
  }
  if (prefs.panelPlacementLayoutMode !== undefined) {
    next.panelPlacementLayoutMode = prefs.panelPlacementLayoutMode;
  }
  if (prefs.buffer !== undefined) next.buffer = prefs.buffer;
  if (prefs.rowSpacing !== undefined) next.rowSpacing = prefs.rowSpacing;
  if (prefs.panelTilt !== undefined) next.panelTilt = prefs.panelTilt;
  if (prefs.azimuthRestriction !== undefined) {
    next.azimuthRestriction = prefs.azimuthRestriction;
  }
  return next;
}

export function toggleSelectedRoofPlacement(state, onlySelectedRoof) {
  const nextState = {
    ...state,
    panelPlacementOnlySelectedRoof: onlySelectedRoof
  };

  if (onlySelectedRoof) {
    nextState.mode = 'select';
    nextState.selectionMode = 'segment';
  } else {
    nextState.selectedRoof = -1;
    nextState.selectedObjects = {
      ...(state.selectedObjects || {}),
      roofSegments: []
    };
  }

  return nextState;
}

export function resolvePendingPanelForFirstPlacement({
  previousPanels = [],
  nextPanels = [],
  lastRenderedPlacedPanelCount = null,
  manualPanel = null,
  pendingPanel = null
} = {}) {
  const hadNoPlacedPanels =
    countPlacedDesignerPanels(previousPanels) === 0 ||
    lastRenderedPlacedPanelCount === 0;
  const nextHasPanels = countPlacedDesignerPanels(nextPanels) > 0;

  if (manualPanel && nextHasPanels) {
    return { panel: manualPanel, consumeManualPanel: true };
  }
  if (!hadNoPlacedPanels || !nextHasPanels) {
    return { panel: null, consumeManualPanel: false };
  }
  return { panel: pendingPanel || null, consumeManualPanel: false };
}

export function resetLegacyFlagsAfterPlacement(state, targetIndices = null) {
  const segments = Array.isArray(state?.segments) ? state.segments : [];
  if (!segments.length) return state;
  const indices = Array.isArray(targetIndices)
    ? targetIndices
    : Array.isArray(state?.selectedObjects?.roofSegments) &&
        state.selectedObjects.roofSegments.length
      ? state.selectedObjects.roofSegments
      : segments.map((_, index) => index);
  if (!indices.length) return state;
  const indexSet = new Set(indices.map(Number));
  return {
    ...state,
    segments: segments.map((segment, index) =>
      indexSet.has(index) ? { ...segment, is_lagacy: false } : segment
    )
  };
}

export function buildGroundMountSegment(
  gridOption = {},
  segmentOption = {},
  panelOptions = {},
  resolution,
  origin = [150, 150]
) {
  const rows = Number(gridOption.rows);
  const columns = Number(gridOption.columns);
  const panel = panelOptions.solarPanel || {};
  const buffer = Number(panelOptions.buffer);
  const toSceneUnits = (millimeters) =>
    Math.max(0.001, Number(millimeters) / 10 / Number(resolution)) || 0.001;
  const length = toSceneUnits(panel.length);
  const width = toSceneUnits(panel.width);
  const widthTotal = (length + buffer) * columns;
  const heightTotal = (width + buffer) * rows;
  const geometry = [
    [...origin],
    [origin[0] + widthTotal, origin[1]],
    [origin[0] + widthTotal, origin[1] + heightTotal],
    [origin[0], origin[1] + heightTotal]
  ];

  return {
    geometry,
    pitch: Number(segmentOption.pitch),
    azimuth: Number(segmentOption.azimuth),
    height: Number(segmentOption.height),
    lines: Array(geometry.length).fill('Eave')
  };
}
